import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { IconButton } from "@mui/material";
import { useMediaQuery } from "@mui/material";

interface CustomDialogProps {
  component: React.ReactNode;
  title: string;
  openDialog: boolean;
  handleCloseDialog?: () => void;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
  modalPlace?: "center" | "right" | "left";
  fullMobileWidth?: boolean;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    // Let the content area grow and scroll inside the dialog reliably
    flexGrow: 1,
    maxHeight: "calc(100vh - 64px)",
    overflowY: "auto",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const CustomDialog: React.FC<CustomDialogProps> = ({
  component,
  title,
  openDialog,
  handleCloseDialog,
  maxWidth = "sm",
  modalPlace = "center", // Default placement is center
  fullMobileWidth = false,
}) => {
  const isLogin = title === "Login";
  const isfromLoadingPopup = title === "loadingPopup";
  const isLargeScreen = useMediaQuery("(min-width:560px)");
  const isSmallScreen =  useMediaQuery("(max-width:765px)");
  const isMobileFullWidth =
    isSmallScreen &&
    (fullMobileWidth || modalPlace === "right" || modalPlace === "left");
  const isMobileCenterDialog = isSmallScreen && modalPlace === "center" && !isLogin;
  return (
    <React.Fragment>
      <BootstrapDialog
        fullScreen={isSmallScreen}
        maxWidth={
          isLogin
            ? "xl"
            : isMobileFullWidth
            ? false
            : modalPlace === "right" || modalPlace === "left"
            ? false
            : maxWidth
        } // Large width for Login and wider side modals
        fullWidth={isLogin || isMobileFullWidth}
        onClose={handleCloseDialog}
        TransitionComponent={Transition}
        keepMounted
        aria-labelledby="customized-dialog-title"
        open={openDialog}
        PaperProps={{
          style: {
            minHeight: modalPlace === "center" ? "auto" : "100vh",
          },
          sx: {
            position: "fixed",
            top: isMobileFullWidth ? 0 : modalPlace === "center" ? "50%" : 0,
            left: isMobileFullWidth
              ? 0
              : modalPlace === "center"
              ? "50%"
              : modalPlace === "left"
              ? 0
              : "unset",
            right: isMobileFullWidth
              ? 0
              : modalPlace === "right"
              ? 0
              : "unset",
            transform: isMobileFullWidth
              ? "none"
              : modalPlace === "center"
              ? "translate(-50%, -50%)"
              : "none", // Centering logic
            height:
              modalPlace === "right" || modalPlace === "left"
                ? "100vh"
                : "auto", // Full height if right or left
            width: isLogin
              ? "50%"
              : isMobileFullWidth
              ? "100vw"
              : modalPlace === "right" || modalPlace === "left"
              ? "40vh"
              : isMobileCenterDialog
              ? "90vw"
              : "auto",

            minWidth: isMobileFullWidth
              ? "auto"
              : modalPlace === "right" || modalPlace === "left"
              ? isLargeScreen
                ? "400px"
                : "auto"
              : isMobileCenterDialog
              ? "320px"
              : isLargeScreen
              ? "400px"
              : title === "Login"
              ? "300px"
              : "auto",
            maxWidth: isMobileFullWidth
              ? "100vw"
              : isMobileCenterDialog
              ? "90vw"
              : title === "Quick Add" && !isLargeScreen
              ? "300px"
              : "auto",
            margin: 0,
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        {!isfromLoadingPopup && 
        <DialogTitle
          sx={{ m: title ? 0 : 1, p: 2 }}
          style={{
            margin: isLogin ? "0px 0px 20x" : "",
            paddingLeft: isLogin ? "37px" : "",
            fontSize: isLogin ? "28px" : "18px",
            fontFamily: isLogin ? "Albert Sans, sans-serif" : "",
            // paddingRight: "50px",
          }}
        >
          {title}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: isLogin ? 22 : 8,
              top: isLogin ? 18 : 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
           }
        <DialogContent dividers sx={{ flexGrow: 1 }}>
          {component}
        </DialogContent>
      
      </BootstrapDialog>
    </React.Fragment>
  );
};

export default CustomDialog;
